import SeoSettings from './seo-settings'

export default SeoSettings
